import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Box, Button, Grid, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import LangEnum from '../../lang/LangEnum';
import { useApplicationContext } from '../../modules/context/ApplicationContext/ApplicationContext';
import { useTranslation } from '../../modules/translation/TranslationContext';
import useTeceoStyles from '../../useTeceoStyles';
import TeceoShortLogo from '../TeceoShortLogo';
import { TeceoModal } from './TeceoModal';

type StorefrontNotFilledModalProps = {
  open: boolean;
  onClose: () => void;
};

const StoreNotVerifiedModal = ({ open, onClose }: StorefrontNotFilledModalProps) => {
  const { classes: teceoClasses } = useTeceoStyles();
  const { state, team } = useApplicationContext();

  const { translate } = useTranslation();

  return (
    <TeceoModal open={open} onClose={onClose} title=" " dialogProps={{ maxWidth: 'xs' }}>
      <Box
        sx={{
          p: 1,
        }}
      >
        <Grid
          container
          spacing={3}
          sx={{
            justifyContent: 'center',
          }}
        >
          <Grid size={3}>
            <TeceoShortLogo />
          </Grid>
          {team?.store?.inPendingVerification ? (
            <>
              <Grid size={12}>
                <Typography gutterBottom>ei, {state.user?.name}!</Typography>
                <Typography>
                  {translate(LangEnum.MY_NETWORK_STORE_NOT_VERIFIED_MODAL_TITLE)}
                </Typography>
              </Grid>
              <Grid
                sx={{
                  justifyContent: 'center',
                }}
                size={12}
              >
                <Grid container spacing={1}>
                  <Grid
                    container
                    sx={{
                      justifyContent: 'center',
                    }}
                    size={12}
                  >
                    <Button variant="contained" color="primary" onClick={onClose}>
                      {translate(LangEnum.MY_NETWORK_STORE_NOT_VERIFIED_MODAL_OK)}
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </>
          ) : (
            <>
              <Grid size={12}>
                {state.user?.name && (
                  <Typography gutterBottom>
                    {translate(LangEnum.MY_NETWORK_STORE_NOT_VERIFIED_MODAL_OOPS, {
                      userName: state.user.name,
                    })}
                  </Typography>
                )}
                <Typography>
                  {translate(LangEnum.MY_NETWORK_STORE_NOT_VERIFIED_MODAL_TWO_DAYS_INFO)}
                </Typography>
              </Grid>
              <Grid
                sx={{
                  justifyContent: 'center',
                }}
                size={12}
              >
                <Grid container spacing={1}>
                  <Grid
                    container
                    sx={{
                      justifyContent: 'center',
                    }}
                    size={12}
                  >
                    <Link to={`/${team?.store?.slug}`} className={teceoClasses.link}>
                      <Button variant="contained" color="primary" endIcon={<ArrowForwardIcon />}>
                        {translate(LangEnum.MY_NETWORK_STORE_NOT_VERIFIED_MODAL_MAKE_MY_SHOWCASE)}
                      </Button>
                    </Link>
                  </Grid>
                </Grid>
              </Grid>
            </>
          )}
        </Grid>
      </Box>
    </TeceoModal>
  );
};

export default StoreNotVerifiedModal;
